import type { CollectionConfig } from "../../core/types";
import { cowryGeometryRanges } from "../../geometry/cowryGeometryParams";
import {
  genesisFinishDefinitions,
  genesisFinishFamilies,
  genesisFormFamilies,
  genesisPaletteFamilies,
  genesisPatternDefinitions,
  genesis002PatternFamilies,
  genesisSizeWeights,
  genesisVentralStyle,
} from "../genesis/designFamilies";
import { genesisPalettes } from "../genesis/palettes";
import { genesisRarityForSize, genesisSizeScale } from "../genesis/rarity";
import { validateCollectionConfig } from "../validateCollectionConfig";

export const genesis002Collection: CollectionConfig = validateCollectionConfig({
  id: "cowry-genesis-002",
  publicId: "kowry-net-genesis-002",
  name: "Kowry Net: Genesis 002",
  version: "2.0.0",
  itemCount: 1000,
  geometryProfile: "classic-smooth-cowry-v2",
  sizeWeights: genesisSizeWeights,
  sizeScale: genesisSizeScale,
  rarityForSize: genesisRarityForSize,
  formFamilies: genesisFormFamilies,
  finishFamilies: genesisFinishFamilies,
  patternFamilies: genesis002PatternFamilies,
  paletteFamilies: genesisPaletteFamilies,
  ventralStyle: genesisVentralStyle,
  ventralTreatment: { foldEmphasis: 1.65, materialEmphasis: true },
  lathePropulsion: {
    axisAlignment: "shell-endpoints",
    foldSeating: 0,
    diameter: 2.3,
    middleBulge: 4,
    chamberDetail: 1,
    opacity: 0.35,
    filamentOpacity: 0.35,
    axisOffset: 0,
    endpointInset: 0.005,
    profileEasing: 3,
    filamentClearance: 0,
  },
  finishDefinitions: genesisFinishDefinitions,
  patternDefinitions: genesisPatternDefinitions,
  paletteDefinitions: genesisPalettes,
  geometryConstraints: cowryGeometryRanges,
  textureResolution: 2048,
  reviewTextureResolution: 512,
  defaultAssetFormats: ["glb"],
  naming: { itemPrefix: "kowry", tokenPadding: 4 },
});
